<div
  (click)="handleClick()"
  class="reward-card-root"
  [ngClass]="{ bigger: isRewardScreen }"
  *transloco="let t">
  <ng-container *ngIf="showDefaultImage; else rewardImage">
    <div class="card-default-image">
      <nb-icon icon="printer-outline"></nb-icon>
    </div>
  </ng-container>

  <ng-template #rewardImage>
    <img [src]="reward.imgSource" alt="rewardImg"
    (error)="showDefaultImage = true"/>
  </ng-template>

  <div class="reward-card-info">
    <h2
      #rewardNameRef
      [matTooltip]="isRewardNameOverflowing ? reward.name : ''"
      [matTooltipClass]="
        isRewardNameOverflowing ? 'lnr-mat-tooltip-bottom-black' : ''
      "
      [matTooltipPosition]="'above'"
    >
      {{ reward.name }}
    </h2>
    <p
      #rewardTypeRef
      [matTooltip]="isRewardTypeOverflowing ? reward.rewardType : ''"
      [matTooltipClass]="
        isRewardTypeOverflowing ? 'lnr-mat-tooltip-bottom-black' : ''
      "
      [matTooltipPosition]="'above'"
    >
      {{ t(reward.rewardType) }}
    </p>
    <h2 class="offer">{{ reward.discount }}% off</h2>
  </div>

  <div class="reward-actions-local" (click)="$event.stopPropagation()">
    <app-reward-actions
      [reward]="reward"
      (editEvent)="goToRewardEdit(reward)"
      (deleteEvent)="deleteReward()"
      *ngIf="showActions"
      style="width: 100%"
    ></app-reward-actions>
  </div>

</div>
